module.exports = __webpack_public_path__ + "4a375b85f44205c7c08060f8fb44df19.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/eldar-vignette-preview-320.webp.png
// module id = 270
// module chunks = 0